import { useState } from "react";

const useSuccessErrorAlert = () => {
  const [successModal, setSuccessModal] = useState({
    visible: false,
    message: "",
  });

  const [errorModal, setErrorModal] = useState({ visible: false, message: "" });

  const showSuccessMessage = (message, callback) => {
    setSuccessModal({
      visible: true,
      message:
        message && typeof message == "string"
          ? message
          : "Something went wrong, please try again later!",
    });

    setTimeout(() => {
      setSuccessModal({ visible: false, message: "" });
      if (typeof callback === "function") {
        callback();
      }
    }, 3000);
  };

  const showErrorMessage = (message, callback) => {
    setErrorModal({
      visible: true,
      message:
        message && typeof message == "string"
          ? message
          : "Something went wrong, please try again later!",
    });

    setTimeout(() => {
      setErrorModal({ visible: false, message: "" });
      if (typeof callback === "function") {
        callback();
      }
    }, 2000);
  };

  return {
    successModal,
    errorModal,
    showSuccessMessage,
    showErrorMessage,
  };
};

export default useSuccessErrorAlert;
